module.exports = __webpack_public_path__ + "static/media/силовые свободные веса - машина смита.24bad238.jpg";